import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuDetailComponent } from './components/menu-detail/menu-detail.component';
import { MenuComponent } from './components/menu/menu.component';
import { PreviewMenuComponent } from './components/preview-menu/preview-menu.component';

const routes: Routes = [
  { path: 'menu/:id', component: MenuComponent },
  { path: 'menu/:lang/:id', component: MenuComponent },
  { path: 'menu/link/:id', component: MenuComponent },
  { path: 'menu-detail/:id/:type', component: MenuDetailComponent },
  { path: 'menu-detail/:lang/:id/:type', component: MenuDetailComponent },
  { path: 'menu-detail/:lang/:id/:type/:section', component: MenuDetailComponent },
  { path: 'preview/:id/:type', component: PreviewMenuComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuRoutingModule { }


